import React from "react";
const activeColor = "#0A313F";
// CS
export const NucleusLogoSVG = ({ active = false, width="", height="", ...props }) => {
  return (
    <svg
      width="63"
      height="55"
      viewBox="0 0 50 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      
      <path 
        d="M15.792 22.4056C15.792 26.5569 21.9459 31.8915 24 31.8915C26.054 31.8915 32.2079 26.3519 32.2079 22.4056C32.209 21.4528 31.9208 20.5221 31.3815 19.7366C30.8423 18.9511 30.0773 18.3478 29.1877 18.0065C28.2982 17.6651 27.3259 17.6018 26.3996 17.8249C25.4733 18.0481 24.6365 18.5471 24 19.256C23.3634 18.5471 22.5266 18.0481 21.6003 17.8249C20.674 17.6018 19.7018 17.6651 18.8122 18.0065C17.9227 18.3478 17.1577 18.9511 16.6184 19.7366C16.0791 20.5221 15.7909 21.4528 15.792 22.4056Z" 
        fill="#EBF2FE"
      />
      <path 
        d="M46.8181 30.0349L46.5462 29.2017C46.507 29.0807 46.4344 28.9731 46.3367 28.8916C46.2389 28.8101 46.1201 28.7579 45.994 28.7411C45.8679 28.7243 45.7395 28.7436 45.6239 28.7966C45.5082 28.8497 45.41 28.9345 45.3405 29.041C44.7029 30.0136 44.0231 30.978 43.3012 31.9344C43.1803 32.0925 43.096 32.2755 43.0543 32.4702C43.0126 32.6648 43.0146 32.8663 43.0601 33.0601C43.9984 36.9325 43.572 40.0741 41.8234 41.823C39.8312 43.8149 36.0347 44.0952 31.4064 42.5934C30.3837 42.2585 29.3805 41.8668 28.4016 41.4199C30.9193 39.6372 33.2803 37.6429 35.4587 35.4585C47.2144 23.7031 51.3895 9.46127 44.9639 3.03565C40.6159 -1.31259 32.5536 -0.840835 24.0003 3.82758C22.0746 2.76059 20.054 1.87474 17.9644 1.18146C11.5995 -0.884123 6.29759 -0.225871 3.03607 3.03565C-1.37879 7.45029 -0.789439 15.554 3.82369 24.0065C2.75858 25.93 1.87419 27.9482 1.18189 30.0351C-0.88438 36.4005 -0.225908 41.7022 3.03607 44.9637C5.05022 46.9783 7.84225 48 11.1831 48C13.4913 47.9619 15.7794 47.5631 17.9644 46.8181C20.0538 46.1249 22.0742 45.2393 23.9999 44.1727C25.9254 45.2393 27.9458 46.1249 30.0351 46.8181C32.2202 47.5632 34.5083 47.9619 36.8167 48C40.1568 48 42.9495 46.9783 44.9637 44.9637C48.2259 41.7013 48.8843 36.3996 46.8181 30.0349ZM36.8099 4.44186C38.9128 4.44186 40.6505 5.00244 41.8236 6.17526C43.7532 8.10512 44.0716 11.7319 42.7234 16.1651C42.3656 17.3368 41.93 18.4834 41.4196 19.597C37.8457 14.563 33.4503 10.1663 28.4174 6.59084C31.4968 5.18825 34.3951 4.44186 36.8099 4.44186ZM5.40664 16.592C3.90413 11.9637 4.18488 8.16698 6.17705 6.17526C7.32268 5.02986 9.0647 4.45025 11.2189 4.45025C13.0492 4.4883 14.8626 4.81042 16.594 5.40509C21.7972 7.09431 27.3822 10.7433 32.3193 15.6805C34.8551 18.1967 37.1049 20.9856 39.0277 23.9963C38.073 25.5035 37.0305 26.9534 35.9055 28.3382C34.7798 29.7256 33.5827 31.0535 32.3189 32.3164C29.8018 34.8518 27.0122 37.1012 24.0008 39.0234C17.9758 35.1462 12.852 30.0224 8.97475 23.9974C10.8971 20.9859 13.1464 18.1961 15.6818 15.6789C17.0074 14.3518 18.4052 13.0987 19.8687 11.9254L19.9593 11.8525C20.047 11.7821 20.1158 11.6912 20.1597 11.5877C20.2035 11.4843 20.2211 11.3716 20.2107 11.2597C20.2004 11.1478 20.1625 11.0403 20.1004 10.9466C20.0383 10.853 19.9539 10.7762 19.8549 10.7231C18.9478 10.2391 18.0157 9.80336 17.0626 9.41776C16.8334 9.32393 16.5828 9.29482 16.3382 9.33357C16.0935 9.37233 15.8642 9.47747 15.6752 9.63755C14.6021 10.5573 13.5521 11.5269 12.5406 12.5379C10.3563 14.7163 8.36201 17.0773 6.57947 19.595C6.13282 18.6167 5.74126 17.6141 5.40664 16.592ZM16.5936 42.5924C11.965 44.0945 8.16831 43.814 6.17659 41.822C4.18487 39.8301 3.90413 36.0336 5.40619 31.4053C5.74008 30.385 6.13072 29.384 6.5763 28.4073C10.1595 33.4414 14.561 37.8395 19.5979 41.4187C18.6191 41.8657 17.6161 42.2575 16.5936 42.5924Z"
        fill="#EBF2FE"
      />
    </svg>
  );
};
export const DeviceMDMPoliciesSVG = ({
  active = false,
  size = 1,
  ...props
}) => {
  return (
    <svg
      width={40 + size}
      height={32 + size}
      viewBox="0 0 31 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_585_11713)">
      <path 
        d="M5.89258 11.3516V17.2109" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M8.82251 10.375H18.5881C18.5881 9.08001 18.0737 7.83804 17.158 6.92234C16.2423 6.00663 15.0003 5.4922 13.7053 5.4922C12.4103 5.4922 11.1684 6.00663 10.2527 6.92234C9.33695 7.83804 8.82251 9.08001 8.82251 10.375ZM8.82251 10.375V18.1875C8.82251 18.4465 8.9254 18.6949 9.10854 18.878C9.29168 19.0612 9.54007 19.1641 9.79907 19.1641H13.0705" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M9.79883 4.51563L10.7754 6.46876" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M17.6116 4.51563L16.635 6.46876" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M10.7754 19.1641V22.0938" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      </g>
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M6.49805 0C3.18434 0 0.498047 2.68629 0.498047 6V20.6094C0.498047 23.9231 3.18434 26.6094 6.49805 26.6094H14.6817V24.6094H6.49805C4.28891 24.6094 2.49805 22.8185 2.49805 20.6094V6C2.49805 3.79086 4.28891 2 6.49805 2H21.1074C23.3166 2 25.1074 3.79086 25.1074 6V14.1836H27.1074V6C27.1074 2.68629 24.4211 0 21.1074 0H6.49805Z" 
        fill={active ? activeColor : 'white'}
      />
      <path 
        d="M21.0662 22.5056C21.0662 23.7218 22.8691 25.2846 23.4708 25.2846C24.0726 25.2846 25.8755 23.6617 25.8755 22.5056C25.8758 22.2264 25.7914 21.9538 25.6334 21.7236C25.4754 21.4935 25.2513 21.3168 24.9907 21.2167C24.7301 21.1167 24.4453 21.0982 24.1739 21.1636C23.9025 21.2289 23.6573 21.3751 23.4708 21.5828C23.2843 21.3751 23.0392 21.2289 22.7678 21.1636C22.4964 21.0982 22.2116 21.1167 21.951 21.2167C21.6904 21.3168 21.4663 21.4935 21.3083 21.7236C21.1503 21.9538 21.0659 22.2264 21.0662 22.5056Z" 
        fill={active ? activeColor : 'white'}
      />
      <path 
        d="M30.1557 24.7407L30.076 24.4966C30.0646 24.4611 30.0433 24.4296 30.0147 24.4057C29.986 24.3819 29.9512 24.3666 29.9143 24.3617C29.8773 24.3567 29.8397 24.3624 29.8058 24.3779C29.772 24.3935 29.7432 24.4183 29.7228 24.4495C29.536 24.7344 29.3369 25.017 29.1254 25.2972C29.0899 25.3435 29.0652 25.3971 29.053 25.4542C29.0408 25.5112 29.0414 25.5702 29.0547 25.627C29.3296 26.7615 29.2047 27.6819 28.6924 28.1942C28.1088 28.7778 26.9965 28.8599 25.6406 28.4199C25.3409 28.3218 25.047 28.2071 24.7602 28.0761C25.4979 27.5539 26.1896 26.9696 26.8278 26.3296C30.2718 22.8857 31.495 18.7133 29.6125 16.8308C28.3386 15.5569 25.9767 15.6951 23.4708 17.0628C22.9066 16.7502 22.3146 16.4906 21.7025 16.2875C19.8378 15.6824 18.2845 15.8752 17.3289 16.8308C16.0355 18.1241 16.2082 20.4982 17.5597 22.9746C17.2476 23.5381 16.9885 24.1294 16.7857 24.7408C16.1804 26.6056 16.3733 28.1588 17.3289 29.1144C17.919 29.7046 18.737 30.0039 19.7157 30.0039C20.392 29.9927 21.0623 29.8759 21.7025 29.6577C22.3146 29.4546 22.9065 29.1951 23.4707 28.8826C24.0348 29.1951 24.6267 29.4546 25.2388 29.6577C25.879 29.8759 26.5493 29.9928 27.2256 30.0039C28.2042 30.0039 29.0223 29.7046 29.6124 29.1144C30.5681 28.1586 30.7611 26.6053 30.1557 24.7407ZM27.2236 17.2427C27.8397 17.2427 28.3488 17.407 28.6925 17.7506C29.2578 18.316 29.3511 19.3785 28.9561 20.6773C28.8513 21.0206 28.7237 21.3565 28.5741 21.6827C27.5271 20.2079 26.2394 18.9198 24.7649 17.8723C25.667 17.4614 26.5162 17.2427 27.2236 17.2427ZM18.0234 20.8024C17.5832 19.4464 17.6655 18.3341 18.2491 17.7506C18.5848 17.415 19.0951 17.2452 19.7262 17.2452C20.2625 17.2563 20.7937 17.3507 21.301 17.5249C22.8254 18.0198 24.4616 19.0889 25.908 20.5353C26.6509 21.2725 27.31 22.0895 27.8734 22.9716C27.5937 23.4131 27.2882 23.8379 26.9587 24.2436C26.6289 24.6501 26.2781 25.0391 25.9079 25.4091C25.1705 26.1519 24.3532 26.8109 23.4709 27.3741C21.7058 26.2381 20.2047 24.737 19.0688 22.9719C19.632 22.0896 20.2909 21.2723 21.0337 20.5348C21.4221 20.146 21.8316 19.7789 22.2604 19.4352L22.2869 19.4138C22.3126 19.3932 22.3328 19.3666 22.3456 19.3363C22.3585 19.3059 22.3636 19.2729 22.3606 19.2402C22.3575 19.2074 22.3464 19.1759 22.3282 19.1484C22.31 19.121 22.2853 19.0985 22.2563 19.083C21.9906 18.9411 21.7175 18.8135 21.4383 18.7005C21.3711 18.673 21.2977 18.6645 21.226 18.6759C21.1544 18.6872 21.0872 18.718 21.0318 18.7649C20.7174 19.0344 20.4098 19.3184 20.1135 19.6146C19.4735 20.2528 18.8893 20.9445 18.367 21.6821C18.2362 21.3955 18.1215 21.1018 18.0234 20.8024ZM21.3009 28.4197C19.9448 28.8597 18.8325 28.7775 18.249 28.194C17.6655 27.6104 17.5832 26.4981 18.0233 25.1422C18.1211 24.8432 18.2356 24.55 18.3661 24.2639C19.4159 25.7387 20.7054 27.0272 22.181 28.0758C21.8943 28.2067 21.6004 28.3215 21.3009 28.4197Z" 
        fill={active ? activeColor : 'white'}
      />
      <defs>
      <clipPath id="clip0_585_11713">
      <rect width="21.0938" height="21.0938" fill={active ? activeColor : 'white'} transform="translate(3.25586 2.75781)"/>
      </clipPath>
      </defs>
    </svg>
  );
};
export const AccountsSVG = ({ active = false, width="37", height="36", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M20.5 16.125V21.375C20.5 25.75 18.75 27.5 14.375 27.5H9.125C4.75 27.5 3 25.75 3 21.375V16.125C3 11.75 4.75 10 9.125 10H14.375C18.75 10 20.5 11.75 20.5 16.125Z" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M28 8.625V13.875C28 18.25 26.25 20 21.875 20H20.5V16.125C20.5 11.75 18.75 10 14.375 10H10.5V8.625C10.5 4.25 12.25 2.5 16.625 2.5H21.875C26.25 2.5 28 4.25 28 8.625Z" 
        stroke={active ? activeColor : 'white'}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ReportsSVG = ({ active = false, width="37", height="36", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect 
        x="1" 
        y="1" 
        width="26" 
        height="26" 
        rx="5" 
        stroke={active ? activeColor: 'white'} 
        strokeWidth="2" 
        strokeLinejoin="round"
      />
      <path 
        d="M13.6003 8.0004H22.0003" 
        stroke={active ? activeColor: 'white'} 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M13.6003 15.0004H22.0003" 
        stroke={active ? activeColor: 'white'} 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        d="M13.6003 22.0004H22.0003" 
        stroke={active ? activeColor: 'white'} 
        strokeWidth="2" 
        strokeLinecap="round"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M8.00034 9.4004C8.77354 9.4004 9.40034 8.7736 9.40034 8.0004C9.40034 7.2272 8.77354 6.6004 8.00034 6.6004C7.22714 6.6004 6.60034 7.2272 6.60034 8.0004C6.60034 8.7736 7.22714 9.4004 8.00034 9.4004Z" 
        fill={active ? activeColor : "white"}
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M8.00034 16.4004C8.77354 16.4004 9.40034 15.7736 9.40034 15.0004C9.40034 14.2272 8.77354 13.6004 8.00034 13.6004C7.22714 13.6004 6.60034 14.2272 6.60034 15.0004C6.60034 15.7736 7.22714 16.4004 8.00034 16.4004Z" 
        fill={active ? activeColor : "white"}
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M8.00034 23.4004C8.77354 23.4004 9.40034 22.7736 9.40034 22.0004C9.40034 21.2272 8.77354 20.6004 8.00034 20.6004C7.22714 20.6004 6.60034 21.2272 6.60034 22.0004C6.60034 22.7736 7.22714 23.4004 8.00034 23.4004Z" 
        fill={active ? activeColor : "white"}
      />
    </svg>
  );
};
export const FamilySVG = ({ active = false, width="36", height="37", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M15.9602 15C18.1693 15 19.9602 13.2092 19.9602 11C19.9602 8.79088 18.1693 7.00002 15.9602 7.00002C13.7511 7.00002 11.9602 8.79088 11.9602 11C11.9602 13.2092 13.7511 15 15.9602 15Z" 
        stroke={active ? activeColor : 'white'}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M1.96021 7H3.96021V5C3.96021 2.79086 5.75107 1 7.96021 1H23.9602C26.1693 1 27.9602 2.79086 27.9602 5V25C27.9602 27.2091 26.1693 29 23.9602 29H7.96021C5.75107 29 3.96021 27.2091 3.96021 25V23H1.96021" 
        stroke={active ? activeColor : 'white'}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M1.96021 15H3.96021" 
        stroke={active ? activeColor : 'white'}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M1.96021 11H3.96021" 
        stroke={active ? activeColor : 'white'}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M1.96021 19H3.96021" 
        stroke={active ? activeColor : 'white'}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M21.9602 21V19C21.9602 16.7909 20.1693 15 17.9602 15H13.9602C11.7511 15 9.96021 16.7909 9.96021 19V21C9.96021 22.1046 10.8556 23 11.9602 23H19.9602C21.0648 23 21.9602 22.1046 21.9602 21Z" 
        stroke={active ? activeColor : 'white'}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ProvidersSVG = ({active = false, width="42", height="38", ...props}) => {
  return(
    <svg width={width} height={height} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M16.4 29H5.2C2.4 29 1 27.6 1 24.8V13.6C1 10.8 2.4 9.40002 5.2 9.40002H12.2V24.8C12.2 27.6 13.6 29 16.4 29Z" 
        stroke={active ? activeColor : "white"}
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M12.3542 3.80005C12.2422 4.22005 12.2002 4.68205 12.2002 5.20005V9.40005H5.2002V6.60005C5.2002 5.06005 6.4602 3.80005 8.0002 3.80005H12.3542Z" 
        stroke={active ? activeColor : "white"}
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M18.9609 11.201C18.9609 11.9794 20.1148 12.9796 20.4999 12.9796C20.8851 12.9796 22.0389 11.941 22.0389 11.201C22.0391 11.0224 21.9851 10.8479 21.884 10.7006C21.7829 10.5533 21.6394 10.4402 21.4726 10.3762C21.3058 10.3122 21.1236 10.3003 20.9499 10.3422C20.7762 10.384 20.6193 10.4776 20.4999 10.6105C20.3806 10.4776 20.2237 10.384 20.05 10.3422C19.8763 10.3003 19.694 10.3122 19.5272 10.3762C19.3604 10.4402 19.217 10.5533 19.1159 10.7006C19.0148 10.8479 18.9607 11.0224 18.9609 11.201Z" 
        fill={active ? activeColor : "white"}
      />
      <path 
        d="M24.7784 12.6315L24.7274 12.4753C24.7201 12.4526 24.7065 12.4325 24.6881 12.4172C24.6698 12.4019 24.6475 12.3921 24.6239 12.389C24.6002 12.3858 24.5762 12.3894 24.5545 12.3994C24.5328 12.4093 24.5144 12.4252 24.5013 12.4452C24.3818 12.6275 24.2543 12.8084 24.119 12.9877C24.0963 13.0173 24.0805 13.0517 24.0727 13.0882C24.0649 13.1247 24.0652 13.1624 24.0738 13.1988C24.2497 13.9248 24.1697 14.5139 23.8419 14.8418C23.4684 15.2153 22.7565 15.2678 21.8887 14.9863C21.6969 14.9235 21.5089 14.85 21.3253 14.7662C21.7974 14.432 22.2401 14.058 22.6485 13.6485C24.8527 11.4443 25.6355 8.77399 24.4307 7.56919C23.6155 6.75389 22.1038 6.84234 20.5001 7.71767C20.139 7.51761 19.7601 7.35151 19.3683 7.22152C18.1749 6.83423 17.1808 6.95765 16.5693 7.56919C15.7415 8.39693 15.852 9.91638 16.7169 11.5012C16.5172 11.8619 16.3514 12.2403 16.2216 12.6316C15.8342 13.8251 15.9576 14.8192 16.5693 15.4307C16.9469 15.8084 17.4704 16 18.0968 16C18.5296 15.9928 18.9586 15.9181 19.3683 15.7784C19.7601 15.6484 20.1389 15.4824 20.5 15.2824C20.861 15.4824 21.2398 15.6484 21.6316 15.7784C22.0413 15.9181 22.4703 15.9929 22.9031 16C23.5294 16 24.053 15.8084 24.4307 15.4307C25.0424 14.819 25.1658 13.8249 24.7784 12.6315ZM22.9019 7.83285C23.2962 7.83285 23.622 7.93796 23.8419 8.15786C24.2037 8.51971 24.2634 9.19973 24.0106 10.031C23.9436 10.2507 23.8619 10.4656 23.7662 10.6744C23.0961 9.73057 22.2719 8.90617 21.3283 8.23578C21.9057 7.9728 22.4491 7.83285 22.9019 7.83285ZM17.0137 10.111C16.732 9.2432 16.7847 8.53131 17.1582 8.15786C17.373 7.9431 17.6996 7.83442 18.1035 7.83442C18.4467 7.84156 18.7867 7.90195 19.1114 8.01345C20.087 8.33018 21.1342 9.01437 22.0599 9.94009C22.5353 10.4119 22.9572 10.9348 23.3177 11.4993C23.1387 11.7819 22.9432 12.0538 22.7323 12.3134C22.5212 12.5736 22.2968 12.8225 22.0598 13.0593C21.5878 13.5347 21.0648 13.9565 20.5001 14.3169C19.3705 13.5899 18.4098 12.6292 17.6828 11.4995C18.0432 10.9349 18.465 10.4118 18.9403 9.93979C19.1889 9.69096 19.451 9.45601 19.7254 9.23602L19.7424 9.22234C19.7588 9.20915 19.7717 9.1921 19.7799 9.1727C19.7882 9.15331 19.7915 9.13217 19.7895 9.1112C19.7876 9.09022 19.7805 9.07005 19.7688 9.05249C19.7572 9.03493 19.7414 9.02054 19.7228 9.01059C19.5527 8.91983 19.378 8.83813 19.1992 8.76583C19.1563 8.74824 19.1093 8.74278 19.0634 8.75004C19.0175 8.75731 18.9745 8.77703 18.9391 8.80704C18.7379 8.97949 18.541 9.16128 18.3514 9.35085C17.9418 9.75931 17.5679 10.202 17.2337 10.6741C17.1499 10.4906 17.0765 10.3026 17.0137 10.111ZM19.1113 14.9861C18.2434 15.2677 17.5316 15.2151 17.1581 14.8416C16.7847 14.4681 16.732 13.7563 17.0137 12.8885C17.0763 12.6972 17.1495 12.5095 17.2331 12.3264C17.9049 13.2703 18.7302 14.0949 19.6746 14.766C19.4911 14.8498 19.303 14.9233 19.1113 14.9861Z" 
        fill={active ? activeColor : "white"}
      />
      <path 
        d="M21.9998 22H19.1998C18.4298 22 17.7998 22.63 17.7998 23.4V29H23.3998V23.4C23.3998 22.63 22.7698 22 21.9998 22Z" 
        stroke={active ? activeColor : "white"}
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M6.6001 16.4V22" 
        stroke={active ? activeColor : "white"} 
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M12.2002 24.8V5.2C12.2002 2.4 13.6002 1 16.4002 1H24.8002C27.6002 1 29.0002 2.4 29.0002 5.2V24.8C29.0002 27.6 27.6002 29 24.8002 29H16.4002C13.6002 29 12.2002 27.6 12.2002 24.8Z" 
        stroke={active ? activeColor : "white"} 
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"/>
    </svg>
  )
}

export const CsUsersSVG = ({ active = false, width="42", height="38", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 32"//viewBox="0 0 34 35" 
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M25.2 18.6667C25.651 19.1177 26.3823 19.1177 26.8333 18.6667C27.2844 18.2156 27.2844 17.4844 26.8333 17.0333L24.7475 14.9475C23.9665 14.1665 22.7002 14.1665 21.9191 14.9475L16.5667 20.3C15.9833 19.95 15.2833 19.8333 14.5833 19.8333C12.3667 19.8333 10.5 21.7 10.5 23.9167C10.5 26.1333 12.3667 28 14.5833 28C16.8 28 18.6667 26.1333 18.6667 23.9167C18.6667 23.2167 18.4333 22.5167 18.2 21.9333L20.4167 19.7167L22.2833 21.5833C22.7344 22.0344 23.4656 22.0344 23.9167 21.5833C24.3677 21.1323 24.3677 20.401 23.9167 19.95L22.05 18.0833L23.3333 16.8L25.2 18.6667ZM14.5833 25.6667C13.65 25.6667 12.8333 24.85 12.8333 23.9167C12.8333 22.9833 13.65 22.1667 14.5833 22.1667C15.5167 22.1667 16.3333 22.9833 16.3333 23.9167C16.3333 24.85 15.5167 25.6667 14.5833 25.6667Z" 
        fill={active ? activeColor : 'white'}
      />
      <path 
        d="M2.33333 22.1667C2.33333 17.6167 5.95 14 10.5 14C12.4649 14 14.3471 14.7446 15.8679 16.0248C16.3486 16.4295 17.0592 16.4742 17.534 16.0627C18.028 15.6347 18.0791 14.8789 17.6005 14.4337C16.7696 13.661 15.8576 13.0337 14.8167 12.6C16.45 11.3167 17.5 9.21667 17.5 7C17.5 3.15 14.35 0 10.5 0C6.65 0 3.5 3.15 3.5 7C3.5 9.21667 4.55 11.3167 6.3 12.6C2.56667 14.2333 0 17.85 0 22.1667V26C0 27.1046 0.895431 28 2 28H8.16667C8.811 28 9.33333 27.4777 9.33333 26.8333C9.33333 26.189 8.811 25.6667 8.16667 25.6667H2.33333V22.1667ZM5.83333 7C5.83333 4.43333 7.93333 2.33333 10.5 2.33333C13.0667 2.33333 15.1667 4.43333 15.1667 7C15.1667 9.56667 13.0667 11.6667 10.5 11.6667C7.93333 11.6667 5.83333 9.56667 5.83333 7Z" 
        fill={active ? activeColor : 'white'}
      />
    </svg>
  );
};

export const CsConsumerSVG = ({ active = false, width="42", height="38", ...props }) => {
  return (
    <svg 
      width="33" 
      height="34" 
      viewBox="0 0 33 34" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M25.5023 3.56223H5.82088L4.13926 0.548008C3.9505 0.209678 3.59342 0 3.206 0H1.06867C0.478459 0 0 0.478459 0 1.06867C0 1.65888 0.478459 2.13734 1.06867 2.13734H2.57848L4.23804 5.11201L8.0654 13.5805L8.06933 13.5891L8.40643 14.335L4.56373 18.4339C4.28743 18.7286 4.20094 19.1539 4.34019 19.5332C4.47945 19.9124 4.82065 20.1807 5.22202 20.2265L8.72459 20.6268C13.1057 21.1275 17.5295 21.1275 21.9106 20.6268L25.4132 20.2265C25.9996 20.1595 26.4206 19.6298 26.3536 19.0434C26.2866 18.457 25.7569 18.036 25.1705 18.103L21.6679 18.5033C17.4481 18.9856 13.1871 18.9856 8.96728 18.5033L7.57727 18.3445L10.3977 15.336C10.4249 15.3069 10.4503 15.2767 10.4737 15.2455L11.5464 15.3851C13.0495 15.5807 14.569 15.619 16.0801 15.4995C19.6045 15.2208 22.8709 13.5437 25.1514 10.8421L25.9751 9.8663C26.0028 9.83353 26.0284 9.79912 26.052 9.76327L27.5871 7.42381C28.6752 5.76557 27.4857 3.56223 25.5023 3.56223ZM10.5531 13.1005C10.3174 13.0698 10.1142 12.9201 10.015 12.7044L10.0131 12.7002L6.84908 5.69956H25.5023C25.7856 5.69956 25.9556 6.01432 25.8001 6.25122L24.3003 8.53685L23.5182 9.46344C21.6059 11.7288 18.8669 13.1351 15.9115 13.3688C14.5485 13.4766 13.178 13.442 11.8221 13.2656L10.5531 13.1005Z" 
        fill={active ? activeColor : 'white'}
      />
      <path 
        d="M7.48068 22.442C6.30026 22.442 5.34334 23.3989 5.34334 24.5794C5.34334 25.7598 6.30026 26.7167 7.48068 26.7167C8.66109 26.7167 9.61801 25.7598 9.61801 24.5794C9.61801 23.3989 8.66109 22.442 7.48068 22.442Z" 
        fill={active ? activeColor : 'white'}
      />
      <path 
        d="M21.0171 24.5794C21.0171 23.3989 21.9741 22.442 23.1545 22.442C24.3349 22.442 25.2918 23.3989 25.2918 24.5794C25.2918 25.7598 24.3349 26.7167 23.1545 26.7167C21.9741 26.7167 21.0171 25.7598 21.0171 24.5794Z" 
        fill={active ? activeColor : 'white'}
      />
    </svg>
  );
};

export const DevicesSVG = ({ active = false, size = 1, ...props }) => {
  return (
    <svg
      width={40 + size}
      height={32 + size}
      viewBox="0 0 30 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M30.106 13.0116L30.0154 12.7339C30.0024 12.6936 29.9781 12.6577 29.9456 12.6305C29.913 12.6034 29.8734 12.586 29.8313 12.5804C29.7893 12.5748 29.7465 12.5812 29.708 12.5989C29.6694 12.6166 29.6367 12.6448 29.6135 12.6804C29.401 13.0045 29.1744 13.326 28.9337 13.6448C28.8934 13.6975 28.8653 13.7585 28.8514 13.8234C28.8375 13.8883 28.8382 13.9554 28.8534 14.02C29.1661 15.3108 29.024 16.358 28.4411 16.941C27.7771 17.605 26.5116 17.6984 24.9688 17.1978C24.6279 17.0862 24.2935 16.9556 23.9672 16.8066C24.8065 16.2124 25.5934 15.5476 26.3196 14.8195C30.2381 10.901 31.6299 6.15376 29.488 4.01188C28.0386 2.56247 25.3512 2.71972 22.5001 4.27586C21.8582 3.9202 21.1847 3.62491 20.4881 3.39382C18.3665 2.70529 16.5992 2.92471 15.512 4.01188C14.0404 5.48343 14.2369 8.18467 15.7746 11.0022C15.4195 11.6433 15.1247 12.3161 14.894 13.0117C14.2052 15.1335 14.4247 16.9007 15.512 17.9879C16.1834 18.6594 17.1141 19 18.2277 19C18.9971 18.9873 19.7598 18.8544 20.4881 18.606C21.1846 18.375 21.8581 18.0798 22.5 17.7242C23.1418 18.0798 23.8153 18.375 24.5117 18.606C25.2401 18.8544 26.0028 18.9873 26.7722 19C27.8856 19 28.8165 18.6594 29.4879 17.9879C30.5753 16.9004 30.7948 15.1332 30.106 13.0116ZM26.77 4.48062C27.471 4.48062 28.0502 4.66748 28.4412 5.05842C29.0844 5.70171 29.1905 6.91064 28.7411 8.38838C28.6219 8.77894 28.4767 9.16112 28.3065 9.53235C27.1153 7.85435 25.6501 6.38875 23.9725 5.19695C24.9989 4.72942 25.965 4.48062 26.77 4.48062ZM16.3022 8.53068C15.8014 6.98791 15.895 5.72233 16.559 5.05842C16.9409 4.67662 17.5216 4.48342 18.2396 4.48342C18.8497 4.4961 19.4542 4.60347 20.0313 4.8017C21.7657 5.36477 23.6274 6.5811 25.2731 8.22682C26.1184 9.06557 26.8683 9.9952 27.5092 10.9988C27.191 11.5012 26.8435 11.9845 26.4685 12.4461C26.0933 12.9085 25.6942 13.3512 25.273 13.7721C24.434 14.6173 23.5041 15.3671 22.5003 16.0078C20.4919 14.7154 18.784 13.0075 17.4916 10.9991C18.1324 9.9953 18.8821 9.06537 19.7273 8.22629C20.1691 7.78392 20.6351 7.36624 21.1229 6.97514L21.1531 6.95082C21.1823 6.92738 21.2053 6.89706 21.2199 6.86258C21.2345 6.8281 21.2404 6.79053 21.2369 6.75324C21.2335 6.71595 21.2208 6.68009 21.2001 6.64887C21.1794 6.61766 21.1513 6.59207 21.1183 6.57438C20.8159 6.41304 20.5052 6.26779 20.1875 6.13925C20.1111 6.10798 20.0276 6.09827 19.9461 6.11119C19.8645 6.12411 19.7881 6.15916 19.7251 6.21252C19.3674 6.51909 19.0174 6.84228 18.6802 7.1793C17.9521 7.90543 17.2873 8.69242 16.6932 9.53167C16.5443 9.20556 16.4138 8.87137 16.3022 8.53068ZM20.0312 17.1975C18.4883 17.6982 17.2228 17.6047 16.5589 16.9407C15.895 16.2767 15.8014 15.0112 16.3021 13.4684C16.4134 13.1283 16.5436 12.7947 16.6921 12.4691C17.8865 14.1471 19.3537 15.6132 21.0326 16.8062C20.7064 16.9552 20.372 17.0858 20.0312 17.1975ZM19.764 10.4685C19.764 11.8523 21.8154 13.6305 22.5 13.6305C23.1847 13.6305 25.236 11.784 25.236 10.4685C25.2364 10.1509 25.1403 9.84071 24.9606 9.57888C24.7808 9.31705 24.5258 9.11595 24.2293 9.00217C23.9328 8.88839 23.6087 8.86729 23.2999 8.94166C22.9912 9.01603 22.7122 9.18237 22.5 9.41868C22.2878 9.18237 22.0089 9.01603 21.7001 8.94166C21.3914 8.86729 21.0673 8.88839 20.7708 9.00217C20.4743 9.11595 20.2193 9.31705 20.0395 9.57888C19.8597 9.84071 19.7637 10.1509 19.764 10.4685ZM8.5 4.99881H13.0967V6.99881H8.5C5.73858 6.99881 3.5 9.23739 3.5 11.9988V20.0012C3.5 22.7626 5.73858 25.0012 8.5 25.0012H22.5098C25.1756 25.0012 27.3541 22.9151 27.5018 20.2863H29.5041C29.3546 24.0201 26.2803 27.0012 22.5098 27.0012H8.5C4.63401 27.0012 1.5 23.8672 1.5 20.0012V11.9988C1.5 8.13282 4.63401 4.99881 8.5 4.99881Z" 
        fill={active ? activeColor : 'white'}
      />
    </svg>
  );
};
    

export const CampaignsSVG = ({ active = false, width="45", height="37", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 43 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="30.0985"
        cy="13.4024"
        rx="3.70688"
        ry="12.1798"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M26.7093 9.16797C27.839 9.55631 29.6748 9.37979 29.6748 13.2985C29.6748 14.8519 29.0817 17.895 26.7093 17.6408"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M29.7808 1.22266C25.9235 2.94901 17.8081 6.08257 10.1873 6.98722M29.8867 25.5822C23.3175 21.9504 16.2132 20.3099 10.8227 19.568M6.37446 19.1434C5.19646 19.0851 4.19311 19.0843 3.40895 19.1216C-0.912216 14.5463 1.60846 9.23658 3.40895 7.15367C5.52794 7.35357 7.83402 7.26656 10.1873 6.98722M6.37446 19.1434L8.81041 30.7718C8.98693 31.8309 9.78479 33.9491 11.5641 33.9491C12.9762 34.1257 15.5675 33.9068 14.6355 31.6191L9.6577 19.4199M6.37446 19.1434C7.35618 19.1919 8.45919 19.2804 9.6577 19.4199M9.6577 19.4199C10.0368 19.464 10.4254 19.5133 10.8227 19.568M10.1873 6.98722C9.44588 9.70561 8.53504 16.0275 10.8227 19.568"
        stroke="white"
        strokeWidth="2"
      />
      <line
        x1="37.6315"
        y1="5.38568"
        x2="41.2369"
        y2="3.94352"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="37.2067"
        y1="21.2714"
        x2="40.9575"
        y2="22.2764"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="38.0744"
        y1="13.332"
        x2="41.9575"
        y2="13.332"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
export const ToolsSVG = ({ active = false, width="46", height="46", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.0545 35.2534C37.2542 33.0536 36.343 31.3616 35.6144 30.4498L22.0811 16.9165L23.0377 11.1863L19.7621 6.86433L15.8954 4.54434L11.2542 6.08966L15.1212 9.95655C16.7852 11.6206 15.2995 13.7439 14.3486 14.5975C12.4926 16.4535 10.6284 15.7405 9.92831 15.1521L6.06142 11.2851L4.51611 15.9264L6.8361 19.793L11.1581 23.0686L16.8883 22.112L30.4215 35.6453C31.3333 36.3739 33.0254 37.2852 35.2251 35.0854"
        stroke={active ? activeColor : "white"}
        strokeWidth="2"
      />
    </svg>
  );
};
export const CSSettingsSVG = ({ active = false, width="34", height="35", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={"0 0 30 31"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M14.9931 19.4057C17.3115 19.4057 19.191 17.5263 19.191 15.2078C19.191 12.8894 17.3115 11.0099 14.9931 11.0099C12.6746 11.0099 10.7952 12.8894 10.7952 15.2078C10.7952 17.5263 12.6746 19.4057 14.9931 19.4057Z" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M1 16.4392V13.9765C1 12.5212 2.18941 11.3178 3.65867 11.3178C6.1914 11.3178 7.22689 9.5267 5.95352 7.3298C5.22589 6.07043 5.65967 4.43325 6.93303 3.70561L9.35382 2.3203C10.4593 1.66263 11.8866 2.05443 12.5442 3.15988L12.6982 3.42575C13.9575 5.62265 16.0285 5.62265 17.3018 3.42575L17.4558 3.15988C18.1134 2.05443 19.5407 1.66263 20.6462 2.3203L23.067 3.70561C24.3403 4.43325 24.7741 6.07043 24.0465 7.3298C22.7731 9.5267 23.8086 11.3178 26.3413 11.3178C27.7966 11.3178 29 12.5072 29 13.9765V16.4392C29 17.8945 27.8106 19.0979 26.3413 19.0979C23.8086 19.0979 22.7731 20.889 24.0465 23.0859C24.7741 24.3593 24.3403 25.9825 23.067 26.7101L20.6462 28.0954C19.5407 28.7531 18.1134 28.3613 17.4558 27.2558L17.3018 26.99C16.0425 24.7931 13.9715 24.7931 12.6982 26.99L12.5442 27.2558C11.8866 28.3613 10.4593 28.7531 9.35382 28.0954L6.93303 26.7101C5.65967 25.9825 5.22589 24.3453 5.95352 23.0859C7.22689 20.889 6.1914 19.0979 3.65867 19.0979C2.18941 19.0979 1 17.8945 1 16.4392Z" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NotificationBGSVG = ({
  active = false,
  width = "34",
  height = "35",
  ...props
}) => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="16"
        height="12"
        rx="6"
        fill="#0A313F"
        stroke="#0A313F"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AppsSVG = ({ active = false, width="40", height="36", ...props }) => {
  return (
    <svg 
        width={width}
        height={height}
        viewBox="0 0 32 33" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M22.5 2.5V7.5M22.5 7.5V12.5M22.5 7.5H17.5M22.5 7.5H27.5M5 12.5H10C11.3807 12.5 12.5 11.3807 12.5 10V5C12.5 3.61929 11.3807 2.5 10 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V10C2.5 11.3807 3.61929 12.5 5 12.5ZM12.5 22.5C12.5 25.2614 10.2614 27.5 7.5 27.5C4.73858 27.5 2.5 25.2614 2.5 22.5C2.5 19.7386 4.73858 17.5 7.5 17.5C10.2614 17.5 12.5 19.7386 12.5 22.5ZM20 27.5H25C26.3807 27.5 27.5 26.3807 27.5 25V20C27.5 18.6193 26.3807 17.5 25 17.5H20C18.6193 17.5 17.5 18.6193 17.5 20V25C17.5 26.3807 18.6193 27.5 20 27.5Z"
          stroke={active ? activeColor : 'white'} 
          strokeWidth="2" 
          strokeLinecap="round"
        />
    </svg>

  );
};

export const LogoutSVG = ({ active = false, width="40", height="36", ...props }) => {
  return(
    <svg 
      width={width}
      height={height}
      viewBox="0 0 38 33" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M24.5862 19.3107L29.0001 14.8969L24.5862 10.483" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M11.345 14.8967H28.8798" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M14.7934 28.5867C7.17253 28.5867 1 23.4142 1 14.7934C1 6.17251 7.17253 1 14.7934 1" 
        stroke={active ? activeColor : 'white'} 
        strokeWidth="2" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  )
}